import { useEffect } from "react";
import TableRow from "./TableRow";

const WidgetList = (props) => {
    return (
        <>
            <div className="row mt-5">
                <div className="col-md-12">
                    <div className="card border">
                        <div className="card-body py-4">
                            <div id="sai_table_users_wrapper" className="dataTables dt-bootstrap4 no-footer">
                                <div className="table-responsive">
                                    <table className="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
                                        <thead>
                                            <tr className="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
                                                <th className="w-200px sorting">Widget Details</th>
                                                <th className="w-5500px sorting">Other Info</th>
                                                <th className="w-150px text-center">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-gray-600 fw-semibold set-system-user-list">
                                            {props.allWidgets.map((row, index) => (
                                                <TableRow row={row} key={index} deleteSuccess={props.widgetDeleted} editId={props.widgetEditId} />
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default WidgetList;